package com.upcominds.expedite.web

import androidx.compose.runtime.*
import com.upcominds.expedite.di.getKoin
import com.upcominds.expedite.features.splash.AuthCheckState
import com.upcominds.expedite.features.splash.SplashViewModel
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun WebSplashScreen(
    viewModel: SplashViewModel = getKoin().get(),
    toLogin: () -> Unit,
    toHome: () -> Unit
) {
    val authState by viewModel.authCheckState.collectAsStateWeb()

    LaunchedEffect(Unit) {
        viewModel.checkAuthenticationStatus()
    }

    LaunchedEffect(authState) {
        when (authState) {
            is AuthCheckState.Authenticated -> toHome()
            is AuthCheckState.Unauthenticated -> toLogin()
            is AuthCheckState.Loading -> { }
        }
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            height(100.vh)
            width(100.percent)
            backgroundColor(Color.white)
        }
    }) {
        H1 { Text("Expedite") }
    }
}
